import { client } from '@generated/works-api/proxy/client.gen';
import { useUserStore } from '@/stores/user';
import { env } from '@/env';
import { watch } from 'vue';

/**
 * Composable for configuring the @hey-api client with authentication and refresh token headers.
 * This composable automatically updates the client configuration when the user's authentication state changes.
 */
export const useApiClient = () => {
  const userStore = useUserStore();

  const configureClient = () => {
    const token = userStore.getValidToken();
    const refreshToken = userStore.getValidRefreshToken();

    client.setConfig({
      auth: () => token?.replace('Bearer ', '') || undefined,
      baseUrl: env().csRestApiBaseUrl,
      headers: {
        refresh_token: refreshToken || '',
      },
    });
  };

  // Configure the client initially
  configureClient();

  // Watch for changes in the user store and reconfigure the client
  watch(
    () => userStore.user,
    () => {
      configureClient();
    },
    { deep: true }
  );

  return {
    client,
    configureClient,
  };
};
